import React, { Fragment } from "react"
import { css } from "react-emotion"

import { Button, ButtonModal } from "ui"
import AttributesForm from "../../records/components/AttributesForm"
import fieldTypes from "../utils/fieldTypes"

const NewFieldButton = props => (
    <ButtonModal
        button={({ open }) => (
            <Button icon="plus" color="clear" padding="small" margin="none" onClick={open}>
                New Field
            </Button>
        )}
        header={() => `New Field`}
        footerClassName={css`
            justify-content: flex-end;
        `}
        footer={({ close, state }) => [
            <Button
                key="create"
                sideMargin="xsmall"
                color="success"
                onClick={() => {
                    props.onSave(state)
                    close()
                }}
            >
                Create
            </Button>,
            <Button key="cancel" sideMargin="xsmall" onClick={close}>
                Cancel
            </Button>,
        ]}
    >
        {({ setState }) => (
            <AttributesForm
                onChange={setState}
                fields={[
                    { type: "text", label: "Label", api_name: "label" },
                    {
                        type: "dropdown",
                        options: { options: fieldTypes },
                        label: "Type",
                        api_name: "type",
                    },
                    {
                        type: "lookup",
                        displayIf: values => values.type === "lookup",
                        label: "Link to",
                        api_name: "options.lookup_target",
                        options: { lookup_target: "object" },
                    },
                    {
                        type: "long_text",
                        displayIf: values => values.type === "dropdown",
                        label: "Options (one per line)",
                        api_name: "options.options",
                    },
                ]}
            />
        )}
    </ButtonModal>
)
export default NewFieldButton



// WEBPACK FOOTER //
// ./src/features/studio/components/NewFieldButton.js